<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getUserInfos"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-user-name" label-cols-sm="4" label-cols-lg="3" label="User Name" label-for="filter-user-name" size="sm" :model.sync="filter.userName" />
					<app-input-textbox id="fieldset-first-name" label-cols-sm="4" label-cols-lg="3" label="First Name" label-for="filter-first-name" size="sm" :model.sync="filter.firstName" />
					<app-input-textbox id="fieldset-last-name" label-cols-sm="4" label-cols-lg="3" label="Last Name" label-for="filter-last-name" size="sm" :model.sync="filter.lastName" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-email" label-cols-sm="4" label-cols-lg="3" label="Email" label-for="filter-email" size="sm" :model.sync="filter.email" />
					<app-input-combobox-autocomplete :options="approvalGroups" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Group" id="filter-" size="sm" :model.sync="filter.approvalGroupId" @input="getApprovalGroups" @focus="getApprovalGroups" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getUserInfos"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">User Info</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/userinfo/UserInfo.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/userinfo/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/userinfo/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="false"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-userinfo" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="userInfos" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="userInfos.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="User Name" class="table-filter">
							<b-form-input id="input-user-name-table" @input="getUserInfosWithoutLoading" v-model="filter.userName" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="First Name" class="table-filter">
							<b-form-input id="input-first-name-table" @input="getUserInfosWithoutLoading" v-model="filter.firstName" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Last Name" class="table-filter">
							<b-form-input id="input-last-name-table" @input="getUserInfosWithoutLoading" v-model="filter.lastName" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Email" class="table-filter">
							<b-form-input id="input-email-table" @input="getUserInfosWithoutLoading" v-model="filter.email" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Vendor" class="table-filter">
							<v-select append-to-body label="name" :options="vendors" :value="filter.vendorId" :reduce="item => item.id" v-model="filter.vendorId" :filterable="true" @input="getUserInfosWithoutLoading" @search="getVendors"></v-select>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(firstname)="row">
						<a @click="() => ( $router.push({ name: 'userinfodetail', params : { id: row.item.userName } }))" class="a-link-detail">
							{{ row.item.firstName != null && row.item.firstName != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.firstName.slice(0, 30) + (row.item.firstName.length > 30 ? "..." : "" ) : row.item.firstName : "" }}
						</a>
					</template>
					<template v-slot:cell(vendor)="row">
						{{ row.item.vendor != null ? row.item.vendor.name : "" }}
					</template>
<!-- 
					<template v-slot:cell(approvalGroup)="row">
						{{ row.item.approvalGroup != null ? row.item.approvalGroup.name : "" }}
					</template> -->

					<!-- <template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.userName))" :checked="checkAllData.includes(Number(row.item.userName))"></b-form-checkbox>
						</div>
					</template> -->
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-email" label-cols-lg="12"  label="Email" label-for="input-email" size="sm" :model.sync="row.item.email"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-user-name" label-cols-lg="12"  label="User Name" label-for="input-user-name" size="sm" :model.sync="row.item.userName"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.approvalGroupId" label="Approval Group" :selected="row.item.approvalGroup != null ? row.item.approvalGroup.name : ''" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(userInfosPaging != null ? userInfosPaging.dataCount : 0)"
									:per-page="(userInfosPaging != null ? userInfosPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-userinfo.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-userinfo.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoList from '@/models/UserInfo/UserInfoList';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import RoleDetail from '@/models/Core/RoleDetail';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ApprovalGroupFilter from '@/filters/ApprovalGroup/ApprovalGroupFilter';
import ApprovalGroup from '@/models/ApprovalGroup/ApprovalGroup';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		UserInfo, 
		UserInfoList, 
		UserInfoFilter, 
		AppInputTextbox,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"userName": {}, "class" : "th-first-username first-child", "label" : "User Name", key: 'userName', sortable: true}, 
				{"firstName": {}, "class" : "th-first-name", "label" : "First Name", key: 'firstName', sortable: true}, 
				{"lastName": {}, "class" : "th-last-name", "label" : "Last Name", key: 'lastName', sortable: true}, 
				{"email": {}, "class" : "th-email last-child", "label" : "Email", key: 'email', sortable: true}, 
				{"vendor": {}, "class" : "th-vendor d-stack-none", "label" : "Vendor", key: 'vendor', sortable: true}, 
				// {"userLevel": {}, "class" : "th-user-level d-stack-none", "label" : "User Level", key: 'userLevel', sortable: true}, 
				// {"approvalGroup": {}, "class" : "th-approval-group d-stack-none", "label" : "Approval Group", key: 'approvalGroup', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			userInfos: [],
			userInfosPaging: {},
			approvalGroups : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			vendors: [],
		}
	},	
	methods : {
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.name = input;
			}
			if(input == '' && this.filter.vendorId != null)
			{
				filter.id = this.filter.vendorId;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			UserInfo.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
					this.userInfosPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getUserInfosWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			UserInfo.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
					this.userInfosPaging = result
				}
			})
			.catch(error => {});
		},
		getApprovalGroups : async function(input) {
			let filter = new ApprovalGroupFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalGroup.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalGroups = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new UserInfoFilter();
			this.getUserInfos();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getUserInfos();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				UserInfo.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			UserInfo.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			UserInfo.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			UserInfo.deleteData(this, id).then(result => {
				if (result)
				{
					this.getUserInfos();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				UserInfo.deleteMultipleData(this).then(result => {
					this.getUserInfos();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableUserInfoParent = document.getElementById('table-list-userinfo').parentNode;
			tableUserInfoParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableUserInfoParent.scrollWidth - tableUserInfoParent.offsetWidth) == Math.ceil(tableUserInfoParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableUserInfoParent = document.getElementById('table-list-userinfo').parentNode;
			tableUserInfoParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableUserInfoParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new UserInfoFilter();
		// this.getApprovalGroups()
		this.getVendors();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"User Info"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getUserInfos();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getUserInfos();
			}
		},
		sortDesc: {
			handler: function() {
				this.getUserInfos();
			}
		},
		currentPage: {
			handler: function() {
				this.getUserInfos();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getUserInfos();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				UserInfo.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "userinfoindex") {
					this.getUserInfosWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "user_info").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
